import script from "./dashboard-ingredient-list.vue?vue&type=script&setup=true&lang=js"
export * from "./dashboard-ingredient-list.vue?vue&type=script&setup=true&lang=js"

import "./dashboard-ingredient-list.vue?vue&type=style&index=0&id=16af9633&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16af9633"]])

export default __exports__